<div class="portal-flex-container-full error-container">
  <portal-icon-warning class="bg-image" />
  <portal-modal>
    <ng-content title
                select="[title]" />
    <ng-content description
                select="[description]" />

    <ng-content action
                select="[action]" />

    <ng-content footer
                select="[footer]" />
  </portal-modal>
  <div class="brand-name-image bottom-right"></div>
</div>
